import './card.css';
import React from 'react';

const Card = ({ className = '', ...props }) => (
  <div
    className={`card ${className}`.trim()}
    {...props}
  />
);

const CardHeader = ({ className = '', ...props }) => (
  <div className={`card__header ${className}`.trim()} {...props} />
);

// No default padding — callers must pass their own. Previously this
// hardcoded `p-6 pt-0`, which Tailwind compiled into the bundle even
// when the consumer passed `p-4`; both ended up in the cascade and the
// utility that lost the order (consumer's) was silently dropped on the
// sides. CarCard's `p-4 pt-5` was effectively ignored for pl/pr.
const CardContent = ({ className = '', ...props }) => (
  <div className={className} {...props} />
);

const CardTitle = ({ className = '', ...props }) => (
  <h3 className={`card__title ${className}`.trim()} {...props} />
);

export { Card, CardHeader, CardContent, CardTitle };